import { DataBean } from "../DataBean";

export class ByDocumentFactory extends DataBean {


    public async getAccountantConceptCatalogByDocumentFactory(factoryName:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantConceptCatalogByDocumentFactory_String", [factoryName]);
    }

 
}